import { LoadingButton } from '@mui/lab'
import { Box, FormControl, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material'
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useAuthContext } from 'src/auth/useAuthContext'
import CustomInput from 'src/components/customerinput/CustomerInput'
import CustomModal from 'src/components/customerinput/CustomModal'
import { notify } from 'src/components/notify'
import createCampianAssignGroup from 'src/services/campian/createAssignNumber'
import getCampianGroups from 'src/services/campian/getGroupData'
import updateCampianAssignGroup from 'src/services/campian/updateAssignNumber'
import * as Yup from "yup";
export default function AssignNumberModal({ open, close, editData, setReload }) {

    const { user } = useAuthContext()
    const [loading, setLoading] = useState(false)
    const { values, handleChange, handleSubmit, handleBlur, touched, errors, setValues } = useFormik({
        initialValues: {
            display_name: "",
            display_number: "",
            phone_number_id: "",
            waba_id: "",
            group: "",
            msg_limit: "",
            quality_rating: "medium"
        },
        validationSchema: Yup.object({
            display_name: Yup.string()
                .required("Display Name is required"),
            display_number: Yup.string()
                .matches(/^\d+$/, "Display Number must be a number")
                .min(10, "Display Number must be 10 characters")
                .max(10, "Display Number must be  10 characters")
                .required("Display Number is required"),
            phone_number_id: Yup.string()
                .matches(/^\d+$/, "Phone Number ID must be a number")
                .min(15, "Phone Number ID must be 15 digits")
                .max(15, "Phone Number ID must be 15 digits")
                .required("Phone Number ID is required"),
            // waba_id: Yup.string()
            //     .matches(/^\d+$/, "WABA ID must be a number")
            //     .min(15, "WABA ID must be digits")
            //     .max(15, "WABA ID must be digits")
            //     .required("WABA ID is required"),
            msg_limit: Yup.string()
                .matches(/^\d+$/, "Message Limit must be a number")
                .required("Message Limit is required"),
        }),
        onSubmit: async (value) => {
            try {
                if (!value.group) {
                    return notify('Group is required.')
                }
                if (!value.quality_rating) {
                    return notify('Quality rating is required.')
                }


                setLoading(true)
                let data;
                if (editData?.isEdit) {
                    data = await updateCampianAssignGroup(user, { ...value, msg_limit: +value?.msg_limit }, editData?._id)
                } else {
                    data = await createCampianAssignGroup(user, { ...value, msg_limit: +value?.msg_limit })
                }
                if (data) {
                    notify("Created Successfully.", "success")
                    close()
                    setReload((prev) => !prev)
                }
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false)
            }


        }
    })
    const [groupName, setGroupName] = useState([])
    useEffect(() => {
        const fetchData = async () => {
            const data = await getCampianGroups(user, 0, 10000)
            setGroupName(data?._payload || [])

        }
        fetchData()
    }, [])
    useEffect(() => {
        if (editData) {
            const { display_name, display_number, phone_number_id, waba_id, group, msg_limit, phone_number, quality_rating } = editData
            setValues({
                display_name: display_name,
                display_number: display_number || phone_number,
                phone_number_id: phone_number_id,
                waba_id: Number(waba_id),
                group: group?._id,
                msg_limit: msg_limit,
                quality_rating: quality_rating || 'medium',

            })
        }
    }, [open, editData])

    return (
        <div>
            <CustomModal open={open} close={close} heading={editData ? "Update Assign Number" : "Assign Number"} action={<LoadingButton form="assign" type='submit' disabled={loading} loading={loading} variant="contained">Confirm</LoadingButton>}>
                <Box component="form" onSubmit={handleSubmit} id="assign">
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <CustomInput
                                label="Group Name"
                                input={
                                    <Select select fullWidth placeholder='Enter group name.' size="small"
                                        value={values?.group}
                                        onChange={handleChange}
                                        name='group'
                                        displayEmpty
                                        onBlur={handleBlur}
                                    >
                                        <MenuItem value="">Select Group name</MenuItem>
                                        {
                                            groupName.map((it) => {
                                                return (
                                                    <MenuItem key={it?._id} value={it?._id}>{it?.name}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <CustomInput
                                label="Display Name"
                                input={
                                    <TextField fullWidth placeholder='Enter display name.' size="small"
                                        value={values?.display_name}
                                        onChange={handleChange}
                                        name='display_name'
                                        disabled
                                        onBlur={handleBlur}
                                        error={errors.display_name && touched.display_name}
                                        helperText={errors.display_name && touched.display_name ? errors.display_name : ""}
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <CustomInput
                                label="Display Number"
                                input={
                                    <TextField fullWidth placeholder='Enter display number.' size="small"
                                        value={values?.display_number}
                                        onChange={handleChange}
                                        name='display_number'
                                        disabled
                                        onBlur={handleBlur}
                                        inputProps={{ maxLength: 10 }}
                                        error={errors.display_number && touched.display_number}
                                        helperText={errors.display_number && touched.display_number ? errors.display_number : ""}
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <CustomInput
                                label="Phone Number Id"
                                input={
                                    <TextField fullWidth placeholder='Enter phone number id.' size="small"
                                        value={values?.phone_number_id}
                                        onChange={handleChange}
                                        name='phone_number_id'
                                        disabled
                                        inputProps={{ maxLength: 15 }}
                                        onBlur={handleBlur}
                                        error={errors.phone_number_id && touched.phone_number_id}
                                        helperText={errors.phone_number_id && touched.phone_number_id ? errors.phone_number_id : ""}
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <CustomInput
                                label="Waba Id"
                                input={
                                    <TextField fullWidth placeholder='Enter waba id.' size="small"
                                        value={values?.waba_id}
                                        onChange={handleChange}
                                        name='waba_id'
                                        disabled
                                        inputProps={{ maxLength: 15 }}
                                        onBlur={handleBlur}
                                        error={errors.waba_id && touched.waba_id}
                                        helperText={errors.waba_id && touched.waba_id ? errors.waba_id : ""}
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <CustomInput
                                label="Message limit"
                                input={
                                    <TextField fullWidth placeholder='Enter message limit.' size="small"
                                        value={values?.msg_limit}
                                        onChange={handleChange}
                                        name='msg_limit'
                                        onBlur={handleBlur}
                                        error={errors.msg_limit && touched.msg_limit}
                                        helperText={errors.msg_limit && touched.msg_limit ? errors.msg_limit : ""}
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <CustomInput
                                label="Quality Rating"
                                input={
                                    <TextField fullWidth placeholder='Enter Quality rating' size='small' select
                                        value={values?.quality_rating}
                                        onChange={handleChange}
                                        name='quality_rating'
                                        disabled
                                        onBlur={handleBlur}
                                    >
                                        <MenuItem value="low">Low</MenuItem>
                                        <MenuItem value="medium">Medium</MenuItem>
                                        <MenuItem value="high">High</MenuItem>

                                    </TextField>
                                }
                            />
                        </Grid>

                    </Grid>


                </Box>
            </CustomModal>
        </div>
    )
}
